import { Component, OnInit, DoCheck, AfterViewInit, OnChanges, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf, Observable, of, Subscription, throwError } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { files } from '../../../_models/example-data';
import { ProjectService } from '../../../_services/project.service';
import { TestService } from '../../../_services/test.service';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from '../../../consts/beatBlipSubscriptionConsts';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, find, switchMap } from 'rxjs/operators';
import { UserMgmtService } from '../../../_services/user-mgmt.service';
import { UserService } from '../../../_services/user.service';
import { UserRestrictions } from '../../../_models/userRestriction';
import { UserTab } from '../../../_models/UserTab';
import { ProjectData } from 'src/app/_models/project-data';
import { Pipe, PipeTransform } from '@angular/core';
// import { SideNavService } from '../test/test-step/side-nav.service';
// import { ConfirmationDialogService } from '../test/test-step/confirmation-dialog.service';
// import { MatMenuTrigger } from '@angular/material';
// import { Subscription } from 'rxjs';
// import { FileSaverService } from 'ngx-filesaver';
import { saveAs } from 'file-saver';
import * as fileSaver from 'file-saver';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { Location } from '@angular/common';
import _ from 'lodash';
import { ConstantPool } from '@angular/compiler';
declare var $: any;

@Component({
  selector: 'app-locator',
  templateUrl: './locator.component.html',
  styleUrls: ['./locator.component.scss']
})
export class LocatorComponent implements OnInit {
  projectId: string;
  projectData: any;
  awsSettingData: any;
  locatorId: string;
  locatorValueData: any;
  locatorEntryMapValue: any;
  editLocatorTitleForm: UntypedFormGroup;
  addLocatorsForm: UntypedFormGroup;
  updateLocatorsForm: UntypedFormGroup;
  submitted: boolean;
  enableSubmit = false;
  addLocator = false;
  formObj: any;
  keyForinsertComment: any;
  locatorEntryCommentValue: any;
  valueForInsert: any;
  updateEnable: boolean;
  editScreenIndex: number;
  editScreenValueIndex: number
  disableButton: boolean = true;
  valueForUpdate: any;
  subscription: Subscription;
  fromTestStep: boolean = false;
  testStepIndex;
  previousUrl;
  enableBackButton: boolean = false;
  titleForUpdate: any = {};
  selectedLocator: string = "";
  onLocatorAdd = false;
  headerOptions = {
    showSetting: true,
    showSearch: false,
    heading: "Locator Screen",
    data: undefined,
  };
  public searchString: string;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;

  p: number = 1;
  selectedPage: any;
  openPageIndex: number;
  @ViewChild('locatorChild') myModal;



  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private project: ProjectService,
    private toastrService: ToastrService,
    private location: Location,
    private confirmationDialogService: ConfirmationDialogService,
    private setting: SettingService,
    @Inject(DOCUMENT) private document: Document,
  ) {

    if (this.router.getCurrentNavigation().previousNavigation != undefined) {
      this.previousUrl = this.router.getCurrentNavigation().previousNavigation.finalUrl.toString();
 if(this.previousUrl.indexOf('?') != -1){
  var index =  this.previousUrl.indexOf('?');
  this.previousUrl= this.previousUrl.slice(0,index);

  // console.log(this.previousUrl);
  
 }
     

    }

  
  }
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  ngOnInit() {


    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.locatorId = params.get('lid');

        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data["projectName"],
            };
            this.projectData = data;
            //console.log(this.projectData);
            this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
              (data) => {
                this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {

                  //console.log(data);
                  this.fromTestStep = data['Data'];
                })
                this.locatorValueData = data;
                //console.log(this.locatorValueData);
                // if(this.locatorValueData.locatorEntryMap==null){
                //   this.locatorEntryMapValue = {entry:[]} ;
                //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                // }
                // if(this.locatorValueData.locatorEntryMap!=null){
                //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
                // }
                // this.locatorEntryMapValue=[];
                // this.locatorEntryCommentValue=[]

                this.setLocatorData();

              }
            )
          }
        ))

      }
    )
    this.loadForm();
  }
  ngAfterViewInit(){
    this.route.queryParamMap.subscribe((res) => {
      this.testStepIndex = res['params']['index'];
      //console.log(this.testStepIndex);
      if (this.testStepIndex != undefined) {
        this.enableBackButton = true;
        //console.log(this.enableBackButton);
      }
      else {
        this.enableBackButton = false;
        //console.log(this.enableBackButton);
      }

      this.setting.seletedScreenName.subscribe((res) => {
        this.openPageIndex = 4;
        let selectedIndex;
        if (this.enableBackButton) {
          this.selectedLocator = res;
          //console.log(this.selectedLocator);

          setTimeout(()=>
          {
            this.locatorEntryMapValue.forEach((element, i) => {
              if (element.key == this.selectedLocator) {
                selectedIndex = i + 1;
             
              }
            });
            let currentPage = selectedIndex / this.perpageitem;
            this.p = Math.ceil(currentPage);
          }, 500)


          setTimeout(() => {
            document.getElementById(this.selectedLocator).scrollIntoView({ behavior: 'smooth' });
          }, 1000);

          setTimeout(() => {
            //console.log(this.selectedLocator);
            this.selectedLocator = undefined;
          }, 10000)
        }
      })

    })
}
  setLocatorData() {
    this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    if (this.locatorValueData.locatorCommentMap) {
      this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
      this.locatorEntryMapValue.forEach(element => {
        this.locatorEntryCommentValue.forEach(value => {
          if (element.key == value.key) {
            element.comment = value.value;
          }
        });
      });
    }
  }

  onPageChange(newValue) {
    this.perpageitem = newValue;
   // this.p = 1;
  }

  pageChanged(event)
  {
    this.editScreenIndex=null;
  }

  loadForm() {
    this.editLocatorTitleForm = this.formBuilder.group({
      name: [''],
    })

    this.addLocatorsForm = this.formBuilder.group({
      key: ['',],
      value: [''],
      comment: ['']
    })

    this.updateLocatorsForm = this.formBuilder.group({
      key: ['',],
      value: [''],
      comment: ['']
    })
  }

  onUpdateLocator() {
    this.submitted = true;
    if (this.addLocatorsForm.invalid) {
      return;
    }

    this.updateLocatorsForm.value.key =  this.updateLocatorsForm.value.key.trim();
    this.updateLocatorsForm.value.value  =  this.updateLocatorsForm.value.value.trim();
    
    var objFormval = this.updateLocatorsForm.value;

    //console.log(objFormval);

    let locatorMapDataForUpdate = {
      key: objFormval.key,
      value: objFormval.value
    };
    let locatorCommentDataForUpdate = {
      key: objFormval.key,
      value: objFormval.comment
    };

    //console.log(this.locatorValueData, locatorMapDataForUpdate, locatorCommentDataForUpdate);
    let payload = JSON.parse(JSON.stringify(this.locatorValueData));
    let selectedElement = payload.locatorEntryMap.entry[this.editScreenValueIndex].key
    // let entryIndex;
    // payload.locatorEntryMap.entry.forEach((element, i) => {
    //   if (element.key == locatorMapDataForUpdate.key) {
    //     entryIndex = i;
    //   }
    // });

    payload.locatorEntryMap.entry[this.editScreenValueIndex] = locatorMapDataForUpdate;


    let commentIndex;
    if (payload.locatorCommentMap) {
      payload.locatorCommentMap.entry.forEach((element, i) => {
        if (element.key == selectedElement) {
          commentIndex = i;
        }
      });
      if (commentIndex == undefined) {
        payload.locatorCommentMap.entry.push(locatorCommentDataForUpdate)
      }
      else {
        payload.locatorCommentMap.entry[commentIndex] = locatorCommentDataForUpdate;
      }
    }
    else {
      let data =
      {
        entry: []
      };
      data.entry.push(locatorCommentDataForUpdate);
      payload.locatorCommentMap = data;
    }

    //console.log(payload);
    var functionValue = _.omit(payload, ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
    const compareKeyValue = functionValue.locatorEntryMap.entry.filter((f) => f.key == objFormval.key);
    //console.log(compareKeyValue);
    if (compareKeyValue[1]) {
      this.toastrService.clear();
      this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
      return;
    }
    //console.log(functionValue);
    //console.log(this.projectId);
    this.projectId = functionValue.projectId;
    this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
      (data) => {

        this.toastrService.clear();
        this.toastrService.success('Locator data updated successfully');
        this.revertUpdateForm();
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.locatorValueData = data;
            //console.log(this.locatorValueData);
            // if(this.locatorValueData.locatorEntryMap==null){
            //   this.locatorEntryMapValue = {entry:[]} ;
            //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            // }
            // if(this.locatorValueData.locatorEntryMap!=null){
            //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            // }
            // this.locatorEntryMapValue=[];
            // this.locatorEntryCommentValue=[]

            this.setLocatorData();

          }
        )
        var testCaseData = data.split(",");
       
          var counter = 1;
         // var listAffectedTestCase = []
          // for (let i = 0; i < testCaseData.length; i++) {
          //   listAffectedTestCase.push(testCaseData[i].title);
          // }
          //console.log(listAffectedTestCase);
          var toastrMsg = '<p>Following Tasks are being affected : <p>';
          if (testCaseData && testCaseData.length > 0) {
             for (var index = 0; index < testCaseData.length; index++) {
            //   if (testCaseData[index].dynamicTestResult.resultState.status === 'MODIFIED') {
                 toastrMsg += ((counter++) + '. ' + testCaseData[index] + '<br/>');
            //   }
         }
          

          this.toastrService.clear();
          this.toastrService.info(
            toastrMsg, null, {
            enableHtml: true,
          }
          )

        }


      })

  }

  onEditTitle() {
    this.submitted = true;
    if (this.editLocatorTitleForm.invalid) {
      return;
    }

    var objFormval = this.editLocatorTitleForm.value;
    if (this.locatorValueData['parentLocatorId']) {
      this.titleForUpdate = {
        name: objFormval.name,
        id: this.locatorId,
        projectId: this.projectId,
        parentLocatorId: this.locatorValueData.parentLocatorId,
      }
    }
    else {
      this.titleForUpdate = {
        name: objFormval.name,
        id: this.locatorId,
        projectId: this.projectId
      }
    }

    if (! /^[^:|*?<>/\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning('Screen Name is not Valid , Name can not contain /[<>:"\/\\|?*');
      return;
    }
    this.setting.editLocatorSuitTitle(this.titleForUpdate).subscribe(
      (data) => {
        this.toastrService.clear();
        this.toastrService.success('Title updated successfully');
        this.locatorValueData = data;
        this.enableSubmit = false;
        this.project.sendLocatorData(this.projectId);
      })
  }

  enableSubmitF(value) {
    if (this.locatorValueData.name != value) {
      this.enableSubmit = true;
    }
    else {
      this.enableSubmit = false;
    }
  }

  disableSubmit() {
    this.enableSubmit = false;
    //console.log(this.locatorValueData);
    this.editLocatorTitleForm.patchValue({
      name: this.locatorValueData.name
    })
    this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
      (data) => {
        this.locatorValueData = data;
        // if(this.locatorValueData.locatorEntryMap==null){
        //   this.locatorEntryMapValue = {entry:[]} ;
        //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
        // }
        this.setLocatorData();
      }
    )
  }

  delLocator(values) {
    const valueForDelete = this.locatorEntryMapValue.filter((f) => f.key == values);
    //console.log(valueForDelete)
    this.confirmationDialogService.openConfirmDialog('Are you sure to delete ' + values + ' ?')
      .afterClosed().subscribe(res => {
        if (res) {

          this.locatorEntryMapValue.forEach((element, index) => {
            if (element == valueForDelete[0]) this.locatorEntryMapValue.splice(index, 1);
          });

          if (this.locatorEntryCommentValue) {
            this.locatorEntryCommentValue.forEach((element, index) => {
              if (element.key == valueForDelete[0].key) this.locatorEntryCommentValue.splice(index, 1);
            });
          }


          //console.log(this.locatorEntryCommentValue, this.locatorEntryMapValue);
          var functionValue =
          {
            id: this.locatorValueData.id,
            locatorCommentMap: this.locatorValueData.locatorCommentMap,
            locatorEntryMap: this.locatorValueData.locatorEntryMap,
            name: this.locatorValueData.name,
            projectId: this.locatorValueData.projectId,
          }
          //console.log(functionValue);
          this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
            (data) => {
              this.toastrService.clear();
              this.toastrService.success('Locator deleted successfully');
              this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
                (data) => {
                  this.locatorValueData = data;
                  //console.log(this.locatorValueData);
                  this.setLocatorData();
                }
              )
              if (data['testCaseData']) {
                var testCaseData = data['testCaseData'];
                var counter = 1;

                var toastrMsg = '<p>Following Tasks are being affected : <p>';
                if (testCaseData && testCaseData.length > 0) {
                  for (var index = 0; index < testCaseData.length; index++) {
                    if (testCaseData[index].dynamicTestResult.resultState.status === 'MODIFIED') {
                      toastrMsg += ((counter++) + '. ' + testCaseData[index].title + '<br/>');
                    }
                  }
                }

                this.toastrService.clear();
                this.toastrService.info(
                  toastrMsg, null, {
                  enableHtml: true,
                }
                )


                //  this.locatorValueData = data;
              }

            }
          )
        }
      }

      )
    // //console.log(this.locatorValueData);
  }

  addValue()
  {
    console.log("inside value : ");
  }

  addLocators() {
    this.addLocator = true; //comment
    this.disableButton = false; //comment
  }
  revertForm() {
    this.addLocatorsForm.reset();
    this.addLocator = false; //comment
    this.disableButton = true; //comment
  }

  revertUpdateForm() {
    this.updateLocatorsForm.reset();
    this.updateEnable = false;
    this.editScreenIndex = null
  }

  onCancelLocators(){
    this.onLocatorAdd = false;
    this.addLocatorsForm.reset();
  }

  onAddLocators() {
    this.submitted = true;
    this.disableButton = true;
    if (this.addLocatorsForm.invalid) {
      return;
    }
    this.addLocatorsForm.value.key = this.addLocatorsForm.value.key.trim();
    this.addLocatorsForm.value.value = this.addLocatorsForm.value.value.trim();

    var objFormval1 = this.addLocatorsForm.value;
    //console.log(objFormval1);
    if (this.locatorEntryMapValue) {
      //console.log(this.locatorEntryMapValue);

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      const objForCommentMap =
      {
        key: objFormval1.key,
        value: objFormval1.comment
      }

      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Values Are Not Allowed ');
        return;
      }
      console.log("testing...",this.locatorValueData)
      const compareKeyValue = this.locatorValueData.locatorEntryMap.entry.filter((f) => f.key == objForCommentMap.key);
      const duplicateValuePair = this.locatorValueData.locatorEntryMap.entry.filter((f)=> f.value == objFormval1.value);

      if (compareKeyValue[0]) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
        return;
      }

      if (duplicateValuePair[0]) {
        $("#editValue").modal('show');
        return;
      }

      this.locatorEntryMapValue.unshift(objFormval1);
      if (this.locatorValueData.locatorCommentMap) {
        this.locatorValueData.locatorCommentMap.entry.unshift(objForCommentMap);
      }
      else {
        let data =
        {
          entry: []
        }
        data.entry.push(objForCommentMap);
        this.locatorValueData.locatorCommentMap = data;
      }
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data) => {
          //console.log(data);

          this.addLocator = false;
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.addLocatorsForm.reset();
        }
      )
    }
    else {
      //console.log('null');
      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Value Are Not Allowed ');
        return;
      }
      this.locatorEntryMapValue = { entry: [] };
      this.locatorValueData.locatorCommentMap = {
        entry: [
          {
            key: objFormval1.key,
            value: objFormval1.comment
          }
        ]
      }

      this.locatorEntryMapValue.entry.unshift(objFormval1);

      this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data) => {

          this.addLocator = false;
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.locatorValueData = data;
              this.setLocatorData();
              //console.log(this.locatorEntryMapValue);
              //console.log(this.locatorValueData);
              this.addLocatorsForm.reset();
            }
          )
        }
      )
    }

  }

  addDuplicateValues()
  {
    var objFormval1 = this.addLocatorsForm.value;
    const objForCommentMap =
    {
      key: objFormval1.key,
      value: objFormval1.comment
    }

    this.locatorEntryMapValue.unshift(objFormval1);
    if (this.locatorValueData.locatorCommentMap) {
      this.locatorValueData.locatorCommentMap.entry.unshift(objForCommentMap);
    }
    else {
      let data =
      {
        entry: []
      }
      data.entry.push(objForCommentMap);
      this.locatorValueData.locatorCommentMap = data;
    }
    this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
      (data) => {
        //console.log(data);

        this.addLocator = false;
        this.toastrService.clear();
        this.toastrService.success(' Locator added successfully');
        this.addLocatorsForm.reset();
      }
    )
  }

  updateLocator(i, values) {
    this.updateEnable = true;
    this.editScreenIndex = i;
    this.locatorEntryMapValue.forEach((element, index) => {
      if (element.key == values.key) {
        this.editScreenValueIndex = index;
      }
    });

    if (this.locatorValueData.locatorCommentMap) {
      let commentIndex;
      this.locatorValueData.locatorCommentMap.entry.forEach((element, i) => {
        if (element.key == this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].key) {
          commentIndex = i;
        }
      });

      // //console.log(commentIndex, this.locatorValueData.locatorCommentMap.entry[commentIndex].value);
      if (commentIndex != undefined) {
        //console.log("inside if");
        this.updateLocatorsForm.patchValue({
          key: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].key,
          value: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].value,
          comment: this.locatorValueData.locatorCommentMap.entry[commentIndex].value
        })
      }
      else {
        this.updateLocatorsForm.patchValue({
          key: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].key,
          value: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].value,
          comment: ''
        })
      }

    }
    else {
      this.updateLocatorsForm.patchValue({
        key: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].key,
        value: this.locatorValueData.locatorEntryMap.entry[this.editScreenValueIndex].value,
        comment: ""
      })

    }


    // this.confirmationDialogService.updateLocatorPopUp(this.locatorValueData, i)
    //   .afterClosed().subscribe(res => {
    //     if (res) {
    //       this.toastrService.clear();
    //       this.toastrService.success(' locator updated successfully');
    //     }
    //   });
  }

  insertComment(key) {
    this.keyForinsertComment = key;
    if (this.locatorEntryCommentValue) {
      this.valueForInsert = this.locatorEntryCommentValue.filter((f) => f.key == this.keyForinsertComment);
      //console.log(this.locatorEntryCommentValue, this.valueForInsert, this.keyForinsertComment);
      if (this.valueForInsert.length > 0) {
        this.valueForUpdate = this.valueForInsert[0].value;
      }
      else {
        this.valueForUpdate = '';
      }
    }
    else {
      this.valueForUpdate = '';
    }



  }
  onSubmit(insertCommentForm) {
    this.formObj = insertCommentForm.value;
    this.valueForInsert[0].value = Object.values(this.formObj)[0];
    //console.log(this.locatorValueData);
    this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
      (data) => {
        //console.log(data);

        this.addLocator = false;
        this.toastrService.clear();
        this.toastrService.success(' Comment added successfully');
        this.cancelmodal.nativeElement.click();
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.locatorValueData = data;
            this.setLocatorData();
          }
        )
      }
    )
  }
  goBack() {
    // window.history.back();
    this.location.back();

    //console.log('goBack()...');
  }

  navigateToTestSteps() {

    //console.log(this.previousUrl, this.testStepIndex);
    this.router.navigate([this.previousUrl], {
      queryParams:
      {
        index: this.testStepIndex
      }
    })
  }
  sortDir = 1;//1= 'ASE' -1= DSC
  onSortClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('fa-angle-up')) {
      classList.remove('fa-angle-up');
      classList.add('fa-angle-down');
      this.sortDir=-1;
    } else {
      classList.add('fa-angle-up');
      classList.remove('fa-angle-down');
      this.sortDir=1;
    }
    this.sortArr('key');
  }
  sortArr(colName:any){
    this.locatorEntryMapValue.sort((a,b)=>{
      a= a[colName].toLowerCase();
      b= b[colName].toLowerCase();
      return a.localeCompare(b) * this.sortDir;
    });
  }
}
